import { getToken } from './../utils/tokenStorage';
import { jsonFetch } from './../utils/fetch';
import { urls } from './../config';

const cropUnsafeSymbols = (string) => {
  const regexp = /[^0-9a-zA-Z!\-_.*'()\ ]/g;
  return string.replace(regexp, '').replace(/ +/g, ' ');
};

const recursiveDecodeURIComponent = (uriComponent) => {
  try {
    const decodedURIComponent = decodeURIComponent(uriComponent);
    if (decodedURIComponent === uriComponent) {
      return cropUnsafeSymbols(decodedURIComponent);
    }
    return recursiveDecodeURIComponent(decodedURIComponent);
  } catch (e) {
    return cropUnsafeSymbols(uriComponent);
  }
};

const getTasks = (task_type) => {
  if (task_type) {
    return jsonFetch(`${urls.tasks}/?task_type=${task_type}`)
  } else {
    return jsonFetch(`${urls.tasks}`)
  }
};

const getMyTask = () => jsonFetch(urls.myTask);

const acceptTask = id => jsonFetch(`${urls.myTask}/accept`, {
  active_task: { task_id: id },
}, { method: 'POST' });

const completeTask = () => jsonFetch(`${urls.myTask}/complete`, null, { method: 'POST' });

const uploadFiles = fileList => {
  const file = fileList[0];
  var formData = new FormData();
  formData.append('file', file, recursiveDecodeURIComponent(file.name));

  return jsonFetch(`${urls.myTask}/upload`, null, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': `Bearer ${getToken()}`,
    }
  });
};

const actionFiles = fileList => jsonFetch(`${urls.myTask}/update_attachments`, {
  attachments: fileList,
}, { method: 'POST' });

const viewTask = (taskId) => jsonFetch(`${urls.tasks}/${taskId}/view`);

export default {
  getTasks,
  getMyTask,
  acceptTask,
  completeTask,
  uploadFiles,
  actionFiles,
  viewTask
};



// WEBPACK FOOTER //
// ./src/api/tasks.js